<template>
  <v-card>
    <v-card-title class="headline py-2">
      Совместный доступ
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close-dialog')" class="mx-0"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pt-0">
      <v-layout row wrap>
        <v-flex xs12 v-if="owner">
          <b>Владелец:</b> {{owner}}
        </v-flex>
        <v-flex xs12>
          <v-data-table :headers="headers" :items="scopeList" hide-actions no-data-text="Данные отсутствуют">
            <template slot="items" slot-scope="props">
              <td class="pl-1">{{ props.item.name }}</td>
              <td class="text-xs-center">{{ (props.item.recursive) ? 'Включая подчиненных' : 'Только выбранным' }}</td>
              <td class="text-xs-center" v-if="data.writable">
                <v-select :items="accessesList" v-model="props.item.access" hide-details class="pa-0 ma-0" height="30" @change="changeAccess(props.item)"></v-select>
              </td>
              <td class="text-xs-center" v-else>{{ (props.item.access==='w') ? 'Доступно редактирование' : 'Только чтение' }}</td>
              <td class="text-xs-center pa-0 ma-0" v-if="data.writable">
                <v-btn class="red--text" icon flat @click="deleteObject(props.item.id)"><v-icon>close</v-icon></v-btn>
              </td>
            </template>
          </v-data-table>
          <span v-if="data.writable" class="dashed pointer pull-right my-2" @click="showTree=!showTree">{{showTree?'Свернуть панель':'Добавить пользователей'}}</span>
        </v-flex>
        <template v-if="data.writable">
          <v-flex xs6 v-show="showTree">
            <dantser-tree
              ref="beingTree"
              :checkbox="true"
              :selectMode="2"
              :source="treedata"
              :style="{height:'150px', overflow:'scroll', border:'1px solid #c5c5c5'}"
            ></dantser-tree>
          </v-flex>
          <v-flex xs6 class="pl-2" v-show="showTree">
            <v-checkbox label="Включая подчиненные подразделения" v-model="include_children" hide-details></v-checkbox>
            <v-checkbox label="Разрешить редактирование" v-model="can_edit" hide-details></v-checkbox>
            <v-btn color="success" class="mt-4 ml-0" @click="addObject">Добавить</v-btn>
            <p class="red--text" v-show="existError">Такой пользователь уже существует в списке</p>
          </v-flex>
        </template>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
  import {mapGetters} from 'vuex'
  
  export default {
    name : "ScopeForm",
  
    props:{
      data:{
        type: Object,
        required: true,
      },
    },
    
    computed:{
      type(){
        return (this.data.key.indexOf('directory')>-1) ? 'directory' : 'file'
      },
      ...mapGetters('app/org', ['getPostById','getContainerById']),
    },
    
    created(){
      this.getPermissions()
      this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
        this.treedata = usersTree
      })
      if(this.data.writable){
        this.headers.push({ text: 'Действия', align: 'center', sortable: false, width: 40 })
      }
    },
    
    data(){
      return {
        scopeList: [],
        headers: [
          { text: 'Пост/Подразделение', align: 'left', sortable: false, class: 'pl-0' },
          { text: 'Доступ', align: 'center', sortable: false, width: 200 },
          { text: 'Права', align: 'center', sortable: false, width: 300 },
        ],
        can_edit: false,
        include_children: false,
        existError: false,
        showTree: false,
        treedata: [],
        accessesList: [
          { value: 'r', text: 'Только чтение' },
          { value: 'w', text: 'Доступно редактирование' }
        ],
        owner: null
      }
    },
    
    methods:{
      getPermissions(){
        this.$store.dispatch('disk/getPermissions', {id: this.data.id, type: this.type}).then( response => {
          this.scopeList = response
          let posts = [], containers = []
          this.scopeList.map( item => {
            if (item.department_id){
              let container = this.getContainerById(item.department_id)
              if(container.loaded){
                this.$set(item, 'name', container.name)
              } else if(!containers.includes(item.department_id)){
                containers.push(item.department_id)
              }
            } else if(item.post_id){
              let post = this.getPostById(item.post_id)
              if(post.loaded){
                let name = (post.fullname) ? post.name+' ('+post.fullname+')' : post.name
                this.$set(item, 'name', name)
              } else if(!posts.includes(item.post_id)){
                posts.push(item.post_id)
              }
            }
          })
  
          if(this.data.owner){
            let post = this.getPostById(this.data.owner.post_id)
            if(post.loaded){
              this.owner = post.name+' ('+post.fullname+')'
            } else if(!posts.includes(this.data.owner.post_id)) {
              posts.push(this.data.owner.post_id)
            }
          }
          
          this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
            this.$store.commit('app/org/addPosts', response.posts_data)
            this.$store.commit('app/org/addContainers', response.containers_data)
            
            this.scopeList.map( item => {
              if (item.department_id){
                let container = this.getContainerById(item.department_id)
                if(container.loaded){
                  this.$set(item, 'name', container.name)
                } else {
                  this.$set(item, 'name', 'Неизвестный объект')
                }
              } else if(item.post_id){
                let post = this.getPostById(item.post_id)
                if(post.loaded){
                  let name = (post.fullname) ? post.name+' ('+post.fullname+')' : post.name
                  this.$set(item, 'name', name)
                } else {
                  this.$set(item, 'name', 'Неизвестный объект')
                }
              }
            })
  
            if(this.data.owner){
              let post = this.getPostById(this.data.owner.post_id)
              if(post.loaded){
                this.owner = post.name+' ('+post.fullname+')'
              } else {
                this.owner = 'Неизвестный объект'
              }
            }
            
          })
        })
      },
      
      addObject(){
        let nodes = this.$refs['beingTree'].getNodesByProp('selected', true)
        if(nodes.length>0){
          let data = []
          nodes.map( node => {
            this.$refs['beingTree'].setSelected(node.id, false)
            if( this.scopeList.findIndex( el => (el.post_id === node.id || el.department_id === node.id )) < 0 ){
              let obj = {
                post_id: (node.element_type==='post') ? node.id : null,
                department_id: (node.element_type==='container') ? node.id : null,
                recursive: (this.include_children && node.element_type !== 'post'),
                object_id: this.data.id,
                name: node.name,
                access: (this.can_edit) ? 'w' : 'r'
              }
              data.push(obj)
            }
          })
          this.include_children = false
          this.can_edit = false
          if(data.length>0){
            this.$store.dispatch('disk/addPermission', {id: this.data.id, type: this.type, data}).then(response => {
              response.map(item=>{
                let obj = data.find(el => item.post_id===el.post_id && item.department_id===el.department_id)
                if(obj){
                  item.name = obj.name
                }
              })
              this.scopeList = this.scopeList.concat(response)
              this.$emit('save', {type: 'scopes', data: this.data, count: this.scopeList.length, dialog: true})
            })
          }
        }
      },
  
      deleteObject(id){
        const index = this.scopeList.findIndex( el => el.id === id )
        if(index >= 0){
          this.$store.dispatch('disk/deletePermission', id).then( response => {
            this.scopeList.splice(index, 1)
            this.$emit('save', {type: 'scopes', data: this.data, count: this.scopeList.length, dialog: true})
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при удалени элемента')
          })
        }
      },
  
      changeAccess(item){
        this.$nextTick(() => {
          let id = item.id
          let data = {access:item.access}
          this.$store.dispatch('disk/updatePermission', {id, data}).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при смене уровня доступа')
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/disk/components/Folders/Forms/ScopeForm.vue